import { createActionGroup,props } from '@ngrx/store';
import { ServiceGroupEntity } from '../../../../entities/mdqx/doctor/service-group.entity';
import { MutationChangeServicegroupArgs, MutationDeleteServiceGroupArgs } from '../../../../mdqx-graphql-types';

export const ServiceGroupActions = createActionGroup({
    source: 'serviceGroup',
    events: {
        'Load Success': props<{ Payload: ServiceGroupEntity[] }>(),
        'Load Request': props<{ Payload?: {} /*todo*/ }>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        // 'Create Request': props<{ Payload: MutationCreateServicegroupArgs }>(),
        'Create Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Create Success': props<{ Payload: ServiceGroupEntity[] }>(),

        'Change Request': props<{ Payload: MutationChangeServicegroupArgs }>(),
        'Change Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Change Success': props<{ Payload: ServiceGroupEntity }>(),

        'delete Request': props<{ Payload: MutationDeleteServiceGroupArgs }>(),
        'delete Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'delete Success': props<{ Payload: number }>(),
    },
});
